import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetEducationForCandidateResponse extends BackendResponse {
  items: Education[];
}

export const getEducationForCandidate =
  withNextApi<GetEducationForCandidateResponse>(
    "/cvp/CvpGetEducationForCandidate"
  );

export interface Education {
  id: number;
  idCandidate: number;
  fromDate: string | null;
  toDate: string | null;
  schoolName: string;
  reference: string;
  educationTypeId: number;
  educationType: string;
  expirationDate: string | null;
  comment: string;
}
